export function selectEarlierDate(date?: Date, compareDate?: Date): Date | undefined {
    if (!compareDate || !date) {
        return date;
    }

    return date.getTime() - compareDate.getTime() > 0 ? date : compareDate;
}
